import { FiltersToApplyOnClientReviewsTable } from "containers/client/components/client-reviews-table/client-reviews-table.types";
import { TouchpointType, TouchpointTypeLabel } from "types/touchpoint";

const TOUCHPOINT_TYPES_FILTERS = [
  { name: TouchpointType.EMAIL, description: "Email" },
  { name: TouchpointType.LANDING_PAGE, description: "Web page" },
  { name: TouchpointType.OTHER, description: "Other" },
];

export const CLIENT_REVIEWS_TABLE_FILTERS_DATA = [
  {
    title: "Channel",
    filterId: "type",
    options: TOUCHPOINT_TYPES_FILTERS,
  },
];

export const CLIENT_REVIEWS_FILTER_ID_TO_TITLE: Record<string, string> = {
  type: "Channel",
  populationType: "Population type",
};

export const CLIENT_REVIEWS_FILTER_VALUE_TO_LABEL: Record<string, string> = {
  [TouchpointType.EMAIL]: TouchpointTypeLabel.EMAIL,
  [TouchpointType.LANDING_PAGE]: TouchpointTypeLabel.LP_TOUCHPOINT,
  [TouchpointType.OTHER]: TouchpointTypeLabel.OTHER,
};

export const DEFAULT_CLIENT_REVIEWS_FILTERS: FiltersToApplyOnClientReviewsTable = {
  type: [],
  populationType: [],
};

export const CLIENT_TABLE_CONFIG_KEYS = {
  approvedCreatives: "client_approved_creatives",
  reviewsCreatives: "client_reviews_creatives",
  approvalQueue: "client_approval_queue",
} as const;

export const CLIENT_REVIEWS_SEARCH_PLACEHOLDER =
  "Search by creative name, subject line, or page title";

export const CLIENT_APPROVAL_QUEUE_SEARCH_PLACEHOLDER = "Search by batch name";
